export default __webpack_public_path__ + "static/media/PhilYoung.bd75512b.jpg";